import Box from "./Box";
import { CHOOSE } from "../core-modules/constants";
import Divider from "./Divider";
import HeadingMain from "./HeadingMain";
import HeadingMedium from "./HeadingMedium";
import LozengeButton from "./LozengeButton";
import NarrowTextColumn from "./NarrowTextColumn";
import NumberedItem from "./NumberedItem";
import PropTypes from "prop-types";
import React from "react";
import SingleColumnLayout from "./SingleColumnLayout";
import Stack from "./Stack";
import RichText from "./RichText";
import { useBrand } from "./BrandContext";
import { useTakebackConfig } from "./TakebackConfigContext";

function How({ setCurrentStep }) {
  const { name } = useBrand();
  const {
    howItWorksDescription,
    stepOneHeadingOverride,
    stepOneCopyOverride,
    stepTwoHeadingOverride,
    stepTwoCopyOverride,
    stepThreeHeadingOverride,
    stepThreeCopyOverride,
    stepFourHeadingOverride,
    stepFourCopyOverride,
    acceptsNonBrandItems,
    discountCodeType,
  } = useTakebackConfig();

  const itemsName = acceptsNonBrandItems ? "items" : `${name} items`;
  const discountCodeTypeText = discountCodeType.replace(/_/g, " ");

  const defaultHeadings = [
    `Add the ${itemsName} you want to return to your takeback basket`,
    "Package up your items and take to the courier drop point",
    "We'll verify your trade-in and send you a discount code",
    `Shop at ${name}`,
  ];

  const defaultBodyTexts = [
    "<p>Simply select your return items using our easy online tool. We'll step you through the process.</p>",
    "<p>We don't want to create unnecessary packaging so re-use a delivery box, or a bag you already have.</p>",
    `<p>Once we've received your takeback, we'll verify it and then email you a discount code for qualifying items.</p>`,
    `<p>Your old item is being given another life, now it's time to use that discount code at ${name} ${discountCodeTypeText}.</p>`,
  ];

  const overrideHeadings = [
    stepOneHeadingOverride,
    stepTwoHeadingOverride,
    stepThreeHeadingOverride,
    stepFourHeadingOverride,
  ];

  const overrideBodyTexts = [
    stepOneCopyOverride,
    stepTwoCopyOverride,
    stepThreeCopyOverride,
    stepFourCopyOverride,
  ];

  const howItems = defaultHeadings.map((defaultHeading, index) => {
    const overrideHeading = overrideHeadings[index];
    const overrideText = overrideBodyTexts[index];
    const defaultBodyText = defaultBodyTexts[index];

    let heading = overrideHeading || defaultHeading;
    let text = overrideText || defaultBodyText;

    if (text == "<p>N/A</p>") {
      text = "";
    }

    return {
      heading: heading,
      text: text,
    };
  });

  return (
    <SingleColumnLayout>
      <NarrowTextColumn text={howItWorksDescription} />
      <Divider></Divider>
      <HeadingMain
        px={[null, null, null, "7.75vw"]}
        pb={[40, null, null, 60]}
        pt={[50, null, 80, null]}
      >
        How it works
      </HeadingMain>
      <Stack divider={<Divider />} itemBoxProps={{ pt: 50, pb: 50 }}>
        {howItems.map((item, index) => {
          return (
            <React.Fragment key={index}>
              <NumberedItem
                number={index + 1}
                px={[null, null, null, "7.75vw"]}
                itemBoxProps={{ pt: [null, null, 30, null] }}
              >
                <Box>
                  <HeadingMedium pb={20}>{item.heading}</HeadingMedium>
                  <RichText>{item.text}</RichText>
                </Box>
              </NumberedItem>
            </React.Fragment>
          );
        })}
      </Stack>
      <Box
        mx={[null, null, null, "7.75vw"]}
        pb={[40, null, null, 60]}
        pt={[50, null, 80, null]}
      >
        <LozengeButton
          onClick={() => {
            setCurrentStep(CHOOSE);
          }}
        >
          Get started
        </LozengeButton>
      </Box>
    </SingleColumnLayout>
  );
}

How.propTypes = {
  setCurrentStep: PropTypes.func.isRequired,
};

export default How;
